/**
 * Sleep for a certain number of milliseconds.
 *
 * @param ms Number of milliseconds
 * @returns A promise
 */
export const sleep = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

/**
 * Delay the response of a promise by a provided milliseconds.
 *
 * @param delayedOperation A delayed operation which returns a Promise
 * @param ms Delay in milliseconds
 * @returns A promise
 */
export const delay = <T>(
  delayedOperation: () => Promise<T>,
  ms: number
): Promise<T> => {
  return new Promise<T>((resolve) => {
    setTimeout(() => resolve(delayedOperation()), ms);
  });
};
